import styled from 'styled-components';

import {  BORDER_COLOR_CONTROLLED_INPUT_NORMAL, BORDER_COLOR_CONTROLLED_INPUT_VALID, BORDER_COLOR_CONTROLLED_INPUT_ERROR, BACKGROUND_SIDE_BAR, BACKGROUND_HEADER } from '../../../globals';


const StyledControlledTextArea = styled.div`
  margin-bottom: 15px;
  padding-left: 6px;
  padding-right: 6px;
  margin-top: 2px;

  .controlled-textarea {
    width: 100%;
    padding: 6px;
    box-sizing: border-box;
    resize: none;
    border-width: 0px 0px 2px 0px;
    border-style: solid;
    border-color: ${BACKGROUND_SIDE_BAR};
    box-shadow: none;
    font-size: 1em;
    border-radius: 0px;
    color: ${BACKGROUND_SIDE_BAR};    
  }

  .controlled-textarea:focus {
    box-shadow: none;
    outline: none;
    border-color: ${BACKGROUND_HEADER};
  }

  ${(p) => (p.inputState && p.inputState === 'normal') && `
    .controlled-textarea {
      border-color: ${BORDER_COLOR_CONTROLLED_INPUT_NORMAL};
    }
  `}

  ${(p) => (p.inputState && p.inputState === 'valid') && `
    .controlled-textarea {
      border-color: ${BORDER_COLOR_CONTROLLED_INPUT_VALID};
    }
  `}

  ${(p) => (p.inputState && p.inputState === 'invalid') && `
    .controlled-textarea {
      border-color: ${BORDER_COLOR_CONTROLLED_INPUT_ERROR};
    }
  `}
`;


export default StyledControlledTextArea;
